<!-- Рисует процентный линейный график с переключаемыми сериями. -->
<template>
  <div class="plc">
    <!-- Легенда с чекбоксами -->
    <div class="plc__legend">
      <BaseCheckbox
        v-for="s in slices"
        :key="'cb-' + s.key"
        :model-value="!hiddenKeys[s.key]"
        @update:modelValue="(val) => setVisible(s.key, val)"
      >
        <span class="legend-item">
          <span
            class="legend-dot"
            :style="{ background: s.color }"
          ></span>
          {{ s.label }}
        </span>
      </BaseCheckbox>
    </div>

    <div v-if="allHidden" class="plc__empty">
      Все статусы скрыты — выберите хотя бы один
    </div>

    <div v-else-if="!visibleSlices.length" class="plc__empty">
      Нет данных для отображения
    </div>

    <div v-else class="plc__list">
      <div v-for="s in visibleSlices" :key="s.key" class="plc__row">
        <div class="plc__row-left">
          <span
            class="plc__dot"
            :style="{ background: s.color }"
          ></span>
          <span class="plc__label">{{ s.label }}</span>
        </div>

        <div class="plc__bar-wrap">
          <div
            class="plc__bar"
            :style="{
              width: barPct(s.value) + '%',
              background: s.color,
            }"
          ></div>
        </div>

        <div class="plc__row-right">
          <span v-if="s.count != null" class="plc__count">
            {{ s.count }} шт.
          </span>
          <span class="plc__amount">
            {{ formatVal(s.value) }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PercentageLineChart",

  props: {
    slices: {
      type: Array,
      required: true,
      // [{ key, label, color, value, count? }]
    },
    formatValue: {
      type: Function,
      default: null,
    },
  },

  data() {
    return {
      hiddenKeys: {},
    };
  },

  computed: {
    visibleSlices() {
      return this.slices.filter((s) => !this.hiddenKeys[s.key]);
    },

    allHidden() {
      return (
        this.slices.length > 0 && this.visibleSlices.length === 0
      );
    },

    total() {
      return this.visibleSlices.reduce(
        (sum, s) => sum + (s.value || 0),
        0
      );
    },
  },

  methods: {
    setVisible(key, visible) {
      this.hiddenKeys = { ...this.hiddenKeys, [key]: !visible };
    },

    barPct(value) {
      if (!this.total) return 0;
      return Math.max((value / this.total) * 100, 0);
    },

    formatVal(v) {
      if (this.formatValue) return this.formatValue(v);
      return Number(v).toLocaleString("ru-RU");
    },
  },
};
</script>

<style scoped>
.plc {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

/* ── Легенда ── */
.plc__legend {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}

/* ── Пустое состояние ── */
.plc__empty {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: #aaa;
  font-size: 14px;
  font-style: italic;
  border: 1.5px dashed #e5e7eb;
  border-radius: 10px;
}

/* ── Список ── */
.plc__list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.plc__row {
  display: grid;
  grid-template-columns: 200px 1fr auto;
  align-items: center;
  gap: 16px;
}

.plc__row-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.plc__dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}

.plc__label {
  font-size: 14px;
  color: var(--color-dark);
  font-weight: 500;
}

.plc__bar-wrap {
  height: 8px;
  background: var(--color-grey);
  border-radius: 100px;
  overflow: hidden;
}

.plc__bar {
  height: 100%;
  border-radius: 100px;
  transition: width 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

.plc__row-right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  min-width: 220px;
}

.plc__count {
  font-size: 13px;
  color: #aaa;
  white-space: nowrap;
  min-width: 90px;
  text-align: right;
}

.plc__amount {
  font-size: 14px;
  font-weight: 600;
  color: var(--color-dark);
  white-space: nowrap;
  min-width: 100px;
  text-align: right;
}

@media screen and (max-width: 900px) {
  .plc__row {
    grid-template-columns: 160px 1fr auto;
  }
}

@media screen and (max-width: 767px) {
  .plc__row {
    grid-template-columns: 1fr auto;
    grid-template-rows: auto auto;
    gap: 8px 12px;
  }

  .plc__bar-wrap {
    grid-column: 1 / -1;
  }

  .plc__row-right {
    justify-content: flex-start;
    min-width: unset;
  }
}
</style>
